<template>
  <div class="crm-chat">
    <template v-if="(messageList!=null && messageList.length>0) || canSend">
      <div class="crm-chat__messages" :class="{'full-height':fullHeight}" ref="chatMessages">
        <div v-for="(message, index) in messageList" :key="index"
             class="crm-chat__row" :class="message.isIncoming ? 'is-in' : 'is-out'">
          <div class="crm-chat__bubble">
            <p class="crm-chat__text">{{ removeHtmlTags(message.body) }}</p>
            <span class="crm-chat__time">{{ message.date }}</span>
          </div>
        </div>
      </div>

      <div class="crm-chat__composer">
        <b-textarea
            :disabled="isInputDisabled"
            v-model="newMessage.body"
            rows="1"
            max-rows="4"
            class="crm-chat__input"
            :placeholder="msg('Type a message...')"
        />
        <b-button
            :disabled="isButtonDisabled || isInputDisabled"
            variant="primary"
            class="crm-chat__send"
            v-b-tooltip
            :title="msg('Send')"
            @click="sendMessage"
        >
          <i class="fas fa-paper-plane"></i>
        </b-button>
      </div>

      <div v-if="!isInputDisabled" class="crm-chat__quick">
        <span class="crm-chat__quick-label">{{ msg('Quick Responses') }}</span>
        <b-button size="sm" variant="outline-primary" pill class="crm-chat__chip" @click="generatePhoneAndBookingText()">
          <i class="fas fa-phone-alt mr-25"></i> {{ msg('Phone number and Bookingcode') }}
        </b-button>
      </div>
    </template>

    <div v-else class="crm-chat__empty">
      <div class="crm-chat__empty-icon"><i class="far fa-comments"></i></div>
      <p>{{ msg("No conversation yet") }}</p>
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "HostawayChatComponent",
  props: {
    contract: {
      type: Object,
      required: true
    },contractId: {
      type: String,
      required: true
    },
    reservationId: {
      type: String,
      required: true
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    contractId: {
      handler() {
        this.refresh();
      },
      immediate: true
    }, reservationId: {
      handler() {
        this.refresh();
      },
      immediate: true
    }
  },
  data: () => ({
    loading: true,
    refreshIntervalId: null,
    ready: true,
    newMessage: {body: '', reservationId: ''},
    hostawayMessage: {},
    messageList: [],
  }),
  mounted() {
    this.startRefresh(); // Start the refresh interval when the component is mounted
  },
  beforeDestroy() {
    this.stopRefresh(); // Clear the interval when the component is destroyed
  },
  computed: {
    canSend() {
      // Backend sets sendEnabled=true for channels that can send with no existing thread
      // (Lodgify's email fallback). Hostaway leaves it unset → original behaviour.
      return !!(this.hostawayMessage && this.hostawayMessage.sendEnabled);
    },
    isInputDisabled() {
      if (this.canSend) return false;
      return this.messageList == null || this.messageList.length < 1;
    },
    isButtonDisabled() {
      return !this.ready;
    },
  },
  methods: {
    ...mapActions('hostaway', ['getMessagesByReservationId', 'sendHostawayMessage']),
    generatePhoneAndBookingText() {
      // Check if the lastname and platformReservationId are available
      const phone = this.contract.client.phone;
      const bookingCode = this.contract.platformReservationId || this.contract.id; // Use platformReservationId, otherwise fallback to id

      // Construct the message
      this.newMessage.body = `Dear customer, for your reference, your registered phone number is: ${phone}. Additionally, your booking code is: ${bookingCode}. Please use these details for website sign-in and accessing your booking.`;    }
    ,
    removeHtmlTags(text) {
      const div = document.createElement('div');
      div.innerHTML = text;
      return div.textContent || div.innerText || ''; // Extracting text content without HTML tags
    },
    startRefresh() {
      // Execute refresh every 10 seconds (10000 milliseconds)
      this.refreshIntervalId = setInterval(() => {
        this.refresh();
      }, 10000);
    },


    stopRefresh() {
      // Clear the interval to stop refreshing
      clearInterval(this.refreshIntervalId);
    },

    getMessageClasses(message, isCrm = false) {
      return {
        'message-container': true,
        'hostaway-message': !isCrm && message.isIncoming,
        'crm-message': isCrm || message.source === 'crm'
      };
    },

    sendMessage() {
      this.ready = false;
      if (this.newMessage.body.trim() !== '') {
        // Add logic to send the new message
        const newMessage = {
          body: this.newMessage.body.trim(),
          reservationId: this.reservationId,
        };
        this.sendHostawayMessage(newMessage).then(this.onMessagesRetrievedAfterSend);

      }
    },
    refresh() {
      if (this.contractId == null) {
        return;
      }
      this.getMessagesByReservationId(this.reservationId).then(this.onMessagesRetrieved);
    },
    onMessagesRetrieved(data) {
      this.hostawayMessage = data["messages"];
      this.messageList = this.hostawayMessage.result;
    },
    onMessagesRetrievedAfterSend(data) {
      this.hostawayMessage = data["messages"];
      this.messageList = this.hostawayMessage.result;
      this.newMessage = {body: '', reservationId: ''};
      this.ready = true;

    },

    formatDate(date) {
      const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // Ensure 24-hour format
      };

      const formattedDate = new Date(date).toLocaleString('de-AT', options);
      return formattedDate.replace(',', ''); // Remove comma (optional)
    }

  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/components/crm-chat.scss';
</style>